import * as React from "react";
import { App } from "./app"

interface OrientationButtonVm {
    FilenameBase: string
    TooltipText: string
    Width: string
    Height: string
    app: App
    buttonID: string
    buttonBaseOffset: number
    position: number
    buttonText: string
    active: boolean
}

export interface OrientationButtonSm {
    buttonStageOffset: number
}

// OrientationButton is a buttonlike control for orientation among large number of results, divided
// into groups of a certain maximum amount, for optimization reasons. This control will let you
// browse the results, click on a certain numbered section of results and the selected section will
// be highlighted in dark blue, following the general color theme and color logics of BDKalk.
// Clicks on these buttons are passed on to a handler within BDKalkCore, similar as for image buttons.
export class OrientationButton extends React.Component<OrientationButtonVm, OrientationButtonSm> {
    constructor(props: OrientationButtonVm) {
        super(props)
    }

    state = {
        buttonStageOffset: 0
    }

    // The final handler is located in BDKalkCore
    onClick() {
        if (this.props.active == true) {
            this.props.app.GetCore().HandleOriButton(this.props.buttonID, this.props.position)
        }
    }

    // This handler will affect the graphics only
    onMouseDown() {
        if (this.props.active == true) {
            this.setState({ buttonStageOffset: 639 })
        }
    }

    // This handler will affect the graphics only
    onMouseUp() {
        if (this.props.active == true) {
            this.setState({ buttonStageOffset: 0 })
        }
    }

    // This handler will affect the graphics only
    onMouseOut() {
        if (this.props.active == true) {
            this.setState({ buttonStageOffset: 0 })
        }
    }

    // Renders the orientation button
    render() {
        const baseName = this.props.FilenameBase;
        const numString = (this.props.position + 1).toString()
        var leftAlign = ((14.5 - (numString.length * 4)).toString() + "px")
        var topAlign = "-23px"

        // Numerical buttons:
        if (this.props.buttonID == "numerical") {

            var fontSizeStr = "14px"

            if (numString.length == 4) {
                fontSizeStr = "10px"
                leftAlign = "2.5px"
                topAlign = "-21px"
            }

            if (numString.length == 5) {
                fontSizeStr = "9px"
                leftAlign = "2px"
                topAlign = "-21px"
            }

            if (numString.length > 5) {
                fontSizeStr = "7px"
                leftAlign = "2px"
                topAlign = "-20px"
            }

            if (this.props.position == this.props.app.state.resultGroup) {
                return <div className="tooltip" style={{ marginLeft: "0px" }}>
                    <div style={{
                        backgroundImage: "url(images/selectionSplitButtons.png)",
                        backgroundPosition: "-" + (this.props.buttonBaseOffset + 324).toString() + "px -0px",
                        width: this.props.Width.toString() + "px",
                        height: this.props.Height.toString() + "px"                        
                    }}>
                    </div>
                    <div style={{
                            fontSize: fontSizeStr,
                            color:"white",
                            width: (numString.length * 6).toString() + "px",
                            height: 16 + "px",
                            position: "relative",
                            top: topAlign,
                            left: leftAlign
                        }}>
                        {numString}
                    </div>
                    <span className="tooltiptext">{this.props.TooltipText}</span>
                </div >;
            }
            else {
                return <div className="tooltip" style={{ marginLeft: "0px" }}>
                    <div
                        onClick={this.onClick.bind(this)}
                        onMouseDown={this.onMouseDown.bind(this)}
                        onMouseUp={this.onMouseUp.bind(this)}
                        onMouseOut={this.onMouseOut.bind(this)}
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/selectionSplitButtons.png)",
                            backgroundPosition: "-" + (this.state.buttonStageOffset + this.props.buttonBaseOffset).toString() + "px -0px",
                            width: this.props.Width.toString() + "px",
                            height: this.props.Height.toString() + "px"
                        }}>
                    </div>
                    <div
                        onClick={this.onClick.bind(this)}
                        onMouseDown={this.onMouseDown.bind(this)}
                        onMouseUp={this.onMouseUp.bind(this)}
                        style={{
                            fontSize: fontSizeStr,
                            cursor: "pointer",
                            color: "black",
                            width: (numString.length * 6).toString() + "px",
                            height: 16 + "px",
                            position: "relative",
                            top: topAlign,
                            left: leftAlign
                        }}>
                        {numString}
                    </div>
                    <span className="tooltiptext">{this.props.TooltipText}</span>
                </div>
            }
        }

        // Non numerical buttons:
        if (this.props.active == true) {
            return <div className="tooltip" style={{ marginLeft: "0px" }}>
                <div
                    onClick={this.onClick.bind(this)}
                    onMouseDown={this.onMouseDown.bind(this)}
                    onMouseUp={this.onMouseUp.bind(this)}
                    onMouseOut={this.onMouseOut.bind(this)}
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/selectionSplitButtons.png)",
                        backgroundPosition: "-" + (this.state.buttonStageOffset + this.props.buttonBaseOffset).toString() + "px -0px",
                        width: this.props.Width.toString() + "px",
                        height: this.props.Height.toString() + "px"
                    }}>

                </div>
                <span className="tooltiptext">{this.props.TooltipText}</span>
            </div>
        }
        else {
            // This button is greyed out and can't be used, it's only cosmetical.
            return <div className="tooltip" style={{ marginLeft: "0px" }}>
                <div style={{
                    backgroundImage: "url(images/selectionSplitButtons.png)",
                    backgroundPosition: "-" + (this.props.buttonBaseOffset + 324).toString() + "px -0px",
                    width: this.props.Width.toString() + "px",
                    height: this.props.Height.toString() + "px"
                }}>

                </div >
                <span className="tooltiptext">{this.props.TooltipText}</span>
            </div >;
        }
    }
}



// WEBPACK FOOTER //
// ./client/view/OrientationButton.tsx